<template>
    <div>

        <div class="row">
            <div class="col s12">
                <h4 class="title">Last Month's Score</h4>
            </div>
        </div>
        <div class="row" v-if="scores">
            <div class="col s12 m6 l6 xl12" id="lastMonthChart_cont">
                <canvas id="lastMonthChart" ref="lastMonthChart"></canvas>
            </div>
            <div class="col s12 m6 l6 xl12">
                <div class="chart-legend" style="padding: 10px">
                    <ul class="collapsible" id="lastMonthChartLegend">
                        <li>
                            <div class="collapsible-header">
                                <span :style="{'background-color':  score_colors[0]}" class="dot"></span>
                                <span class="label">Sales</span>
                                <span class="value" :style="{ 'background-color' : score_colors[0] }">{{ scores.sales_score }}</span>
                            </div>
                            <div class="collapsible-body">
                                <span>{{ comments[0] }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="collapsible-header">
                                <span :style="{'background-color': score_colors[1]}" class="dot"></span>
                                <span class="label">Expenditure</span>
                                <span class="value" :style="{ 'background-color' : score_colors[1] }">{{ scores.expenditure_score }}</span>
                            </div>
                            <div class="collapsible-body">
                                <span>{{ comments[1] }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="collapsible-header">
                                <span :style="{'background-color':  score_colors[2]}" class="dot"></span>
                                <span class="label">Cash Flow</span>
                                <span class="value" :style="{ 'background-color' : score_colors[2] }">{{ scores.cashflow_score }}</span>
                            </div>
                            <div class="collapsible-body">
                                <span>{{ comments[2] }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="collapsible-header">
                                <span :style="{'background-color':  score_colors[3]}" class="dot"></span>
                                <span class="label">Man Power</span>
                                <span class="value" :style="{ 'background-color' : score_colors[3] }">{{ scores.manpower_score }}</span>
                            </div>
                            <div class="collapsible-body">
                                <span>{{ comments[3] }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="collapsible-header">

                                <span :style="{'background-color':  score_colors[4]}" class="dot"></span>
                                <span class="label">Personal</span>
                                <span class="value" :style="{ 'background-color' : score_colors[4] }">{{ scores.personal_score }}</span>
                            </div>
                            <div class="collapsible-body">
                                <span>{{ comments[4] }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row" v-if="!scores && !loading">
            <div class="col s12">
                <p>No scores available for last month</p>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="col s12">
                Loading ...
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
      name: 'LastMonthScore',

      props: {
        viewFrom: String,
      },

      data() {
        return {
          score_colors: [],
          comments: [],
          loading: true,
          scores: null
        }
      },

      mounted () {
        this.loadData();

        this.score_colors = window.AppInfo.stress_score_colors;

        // make sure scores is loaded and component is rendered before accessing refs
        // since the chart container has a v-if, v-if wont rendered until scores is filled
        this.$watch('scores', function() {
          this.loadChart();
        });
      },

      methods: {

        loadData() {
          if(this.$parent.lastMonthUrl) {
            axios.get(this.$parent.lastMonthUrl, {params: {view_from: this.viewFrom}})
              .then(response => {

                if(response.data.results) {
                  this.scores = response.data.results;
                  this.comments = response.data.results.formatted_comments;
                  $(document).ready(function() {
                    $('#lastMonthChartLegend').collapsible();
                  });
                }

                this.loading = !this.loading;
              })
              .catch(err => {
                M.toast({html: 'Error obtaining last month\'s score', classes: 'red accent-2'});
                this.loading = !this.loading;
              });
          } else {
            M.toast({html: 'Error obtaining last month\'s score', classes: 'red accent-2'});
          }

        },

        loadChart() {

          if(this.scores) {
            new Chart(this.$refs.lastMonthChart, {
              type: 'doughnut',
              data: {
                labels: ["Sale", "Expenditure", "Cash Flow", "Man Power", "Personal"],
                datasets: [{
                  label: '# of Votes',
                  data: [
                    this.scores.sales_score,
                    this.scores.expenditure_score,
                    this.scores.cashflow_score,
                    this.scores.manpower_score,
                    this.scores.personal_score,
                  ],
                  backgroundColor: window.AppInfo.stress_score_colors
                }]
              },
              options: {
                legend: {
                  display: false
                }
              }
            });
          }

        }
      }

    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/scores/partials/LastMonthScore.vue